const root = 'auth';

export const AuthRoute = {
  ROOT: root,
  LOGIN: `${root}/login`,
  LOGIN_path: 'login',
  FORGOT_PASS: `${root}/forgot-password`,
  RESET_PASS: `${root}/reset-password`,
}
